import Notifications from './notifications'
import Announcements from './announcements'
import Attachment from './attachment'
import AssetShow from './assets/show'
import AssetInfo from './assets/info'
import EmailShow from './email'
import Gallery from './gallery'
import Search from './search'
import Help from './help'

const routes = [
  { path: '/announcements', component: Announcements },
  { path: '/assets/:fingerprint/info', component: AssetInfo },
  { path: '/assets/:fingerprint/:file_name', component: AssetShow },
  { path: '/:attachable_type/:attachable_id/attachments', component: Gallery },
  { path: '/:attachable_type/:attachable_id/attachments/:id', component: Attachment },
  { path: '/emails/:code', component: EmailShow },
  { path: '/help', component: Help },
  { path: '/notifications', component: Notifications },
  { path: '/search', component: Search }
]

export default routes
